module.exports = __webpack_public_path__ + "payment-bg.fede9613c14c2099792e.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/corporate/img/payment-bg.jpg
// module id = ../../../../../src/assets/corporate/img/payment-bg.jpg
// module chunks = styles